import classNames from 'classnames';
import { type MonetaryValue } from 'ezmoney';

import { formatMonetaryValue } from 'src/core/utils/monetaryValue';

export const BudgetGauge = ({
  spent,
  budget,
  isExceeded,
}: {
  spent: MonetaryValue;
  budget: MonetaryValue;
  isExceeded: boolean;
}) => {
  const width = isExceeded ? 100 : (spent.amount / budget.amount) * 100;
  return (
    <div className="w-full">
      <div className="mb-8 flex justify-between">
        <div>{formatMonetaryValue(spent)}</div>
        <div>{formatMonetaryValue(budget)}</div>
      </div>
      <div className="rounded-8 bg-background-tertiary-default h-[4px]">
        <div
          className={classNames(
            'rounded-8 h-[4px]',
            isExceeded
              ? 'bg-background-primary-warning-default'
              : 'bg-background-primary-brand-default',
          )}
          style={{ width: `${width}%` }}
        />
      </div>
    </div>
  );
};
